export default {
    // getPageConfig(state, data) {
    //     state.pageConfig = state.allConfig.pageConfig;
    // },
}